export default "__VITE_ASSET__B3uI$QCX__"